import React from "react";
import { IconProps } from "../index";
import { colors } from "src/assets";

const Index: React.FC<IconProps> = ({ color, size }) => {
  const localWidth = size * (20 / 24);
  const localHeight = size * (20 / 24);
  const localColor = color || colors.white;
  return (
    <svg width={localWidth} height={localHeight} viewBox="0 0 20 20">
      <path
        d="M435.086,1415.587a10,10,0,1,1,10,10A10.011,10.011,0,0,1,435.086,1415.587Zm1.379,0a8.621,8.621,0,1,0,8.621-8.621A8.63,8.63,0,0,0,436.466,1415.587Zm7.931,6.172V1418.8H441.29a.69.69,0,0,1,0-1.379H444.4v-1.3H441.29a.69.69,0,0,1,0-1.379h2.81l-3.233-3.293a.69.69,0,0,1,.984-.966l3.209,3.269,3.209-3.269a.69.69,0,1,1,.984.966l-3.232,3.293h2.86a.69.69,0,0,1,0,1.379h-3.106v1.3h3.106a.69.69,0,0,1,0,1.379h-3.106v2.958a.69.69,0,0,1-1.379,0Z"
        transform="translate(-435.086 -1405.587)"
        fill={localColor}
      />
    </svg>
  );
};

export default Index;
